import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const CaregiversListPage = lazy(() => import('@pages/caregivers/CaregiversListPage'));
const CreateCaregiver = lazy(() =>
  import('@pages/caregivers/CreateCaregiver').then((m) => ({ default: m.CreateCaregiver }))
);
const EditCaregiverPage = lazy(() =>
  import('@pages/caregivers/EditCaregiverPage').then((m) => ({ default: m.EditCaregiverPage }))
);

// Route Components
const CaregiverTablePage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('caregivers-page-title')}>
        <CaregiversListPage />
      </PageWrapper>
    </Suspense>
  );
};

const CaregiverFormPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('caregivers-create-title')}>
        <CreateCaregiver />
      </PageWrapper>
    </Suspense>
  );
};

const CaregiverEditPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('caregivers-edit-title')}>
        <EditCaregiverPage />
      </PageWrapper>
    </Suspense>
  );
};

// Export Lazy-Loaded Route
export default {
  CaregiverFormPage,
  CaregiverTablePage,
  CaregiverEditPage,
};
